import type { KeyboardEvent, Dispatch, SetStateAction } from 'react';

export const focusElementWhenVisible = (element: HTMLElement) => {
    // This is mostly a hack but it works. Ideally there should
    // be an event listener or mutation observer where it checks
    // when the element is focusable, however I was not able to
    // find an efficient solution.
    setTimeout(() => {
        element.focus();
    }, 50)
}

const accessibleDropdownKeyboardHandler = (
    event: KeyboardEvent<HTMLElement>,
    button: HTMLButtonElement,
    links: HTMLElement[],
    isOpen: boolean,
    setIsOpen: Dispatch<SetStateAction<boolean>>,
    activeLink: number,
    setActiveLink: Dispatch<SetStateAction<number>>,
) => {
    /* eslint-disable-next-line default-case */
    switch (event.key) {
        case 'Tab':
            if (isOpen && ((activeLink < 0 && event.shiftKey) || (activeLink >= links.length - 1 && !event.shiftKey))) {
                setIsOpen(false);
            }
            break;
        case 'Enter':
            if (activeLink >= 0) {
                setIsOpen(false);
                return;
            }
            event.preventDefault();
            if (isOpen) {
                setIsOpen(false);
                return;
            }
            setIsOpen(true);
            focusElementWhenVisible(links[0]);
            break;
        case 'Escape':
            setIsOpen(false);
            button.focus();
            break;
        case 'ArrowDown':
            event.preventDefault();
            if (!isOpen && activeLink < 0) {
                setIsOpen(true);
                focusElementWhenVisible(links[0]);
                return;
            }
            if (activeLink < links.length - 1) {
                links[activeLink + 1].focus();
            }
            break;
        case 'ArrowUp':
            event.preventDefault();
            if (isOpen) {
                if (activeLink > 0) {
                    links[activeLink - 1].focus();
                    return;
                }
                setActiveLink(-1);
                button.focus();
            }
            break;
    }
}

export default accessibleDropdownKeyboardHandler;